import React from "react";
import {Routes, Route} from 'react-router-dom'

import HomePage from "./components/HomePage";
import PostsPage from "./components/PostsPage";
import Feedback from "./components/Feedback";
import SuccessPage from "./components/SuccessPage";
import TermsAndConditions from "./components/TermsAndConditions";
import UserAccountDelete from "./components/UserAccountDelete";
import VideoPlayer from "./components/VideoPlayer";


function App() {
  

  return (
    <div >
      <Routes>
        <Route path='/' element={<HomePage />}></Route>
        <Route path='/PostsPage' element={<PostsPage />}></Route>
        <Route path='/Feedback' element={<Feedback />}></Route>
        <Route path='/SuccessPage' element={<SuccessPage />}></Route>
        <Route path='/PrivacyPolicy' element={<TermsAndConditions />}></Route>
        <Route path='/UserAccountDelete' element={<UserAccountDelete />}></Route>
        <Route path='/VideoPlayer' element={<VideoPlayer />}></Route>
        
      </Routes>
    </div>

  );
}

export default App;